import React, { Suspense, useEffect } from 'react';
import { useRoutes, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { routes } from './router/router';
import Loading from './components/common/Loading';
import { setUser } from './store/actions/userActions';
import { setPhone } from './store/actions/doctorActions';
import ErrorBoundary from './components/ErrorBoundary';
import VConsole from 'vconsole';
import './styles/Knowledge.css';

// import { setDoctors } from './store/actions/doctorActions';

/**
 * 应用程序主组件
 * @returns {JSX.Element} 返回应用程序主组件
 */
function App() {
    const element = useRoutes(routes);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    // 添加一个标记，用于记录是否是首次加载
    const isFirstLoad = React.useRef(true);

    useEffect(() => {
        new VConsole();

        // 检查是否是微信回调
        const params = new URLSearchParams(location.search);
        console.log('params', params);
        const code = params.get('code');
        console.log('code', code);
        const state = params.get('state');
        const jumper = params.get('jumper');
        const phone = params.get('phone');

        if (jumper === 'wechat') {
            const verifierId = params.get('verifierId');

            navigate('/wechat-login-success', {
                state: { verifierId: verifierId, code: code, state: state },
            });

            return;
        }

        if (jumper === 'mirrorLogin') {
            const shopId = params.get('shopId');
            const aiuserId = params.get('aiuserId');
            const gender = params.get('gender');
            const mirrorId = params.get('mirrorId');
            const productName = params.get('productName');
            const ym = params.get('ym');
            const token = params.get('token');
            const wechatGroup = params.get('wechatGroup');
            const aism = params.get('aism');
            const messageSequence = params.get('messageSequence');

            navigate('/mirror-login', {
                state: {
                    shopId,
                    aiuserId,
                    gender,
                    mirrorId,
                    productName,
                    code,
                    state,
                    ym,
                    wechatGroup,
                    aism,
                    token,
                    messageSequence
                },
            });

            return;
        }

        if (phone) {
            dispatch(setPhone(phone));
        }

        // 检查Cookie中的用户信息
        const userInfo = Cookies.get('userInfo');
        if (userInfo) {
            try {
                if (typeof userInfo === 'string' && userInfo !== 'undefined') {
                    const userData = JSON.parse(userInfo);
                    if (userData && typeof userData === 'object') {
                        dispatch(setUser(userData));
                        // 只在首次加载或登录页面时重定向
                        if (
                            isFirstLoad.current &&
                            (location.pathname === '/login' ||
                                location.pathname === '/')
                        ) {
                            navigate('/doctors');
                        }
                    } else {
                        throw new Error('Invalid user data format');
                    }
                } else {
                    Cookies.remove('userInfo', { path: '/' });
                }
            } catch (error) {
                console.error('Invalid user info in cookie:', error);
                Cookies.remove('userInfo', { path: '/' });
            }
        }

        // 设置首次加载标记为 false
        isFirstLoad.current = false;
    }, [dispatch, location, navigate]);

    return (
        <div className="App">
            <ErrorBoundary>
                <Suspense fallback={<Loading />}>{element}</Suspense>
            </ErrorBoundary>
        </div>
    );
}

export default App;
